import { configureStore } from "@reduxjs/toolkit";
import { themeReducer, themeListenerMiddleware } from "./themeSlice";
import { queryReducer } from "./querySlice";
import { discoveryReducer } from "./discoverySlice";
import { restListenerMiddleware, restReducer } from "./restSlice";
import { agentApi } from "./api/agentApi";
import { auditctxApi } from "./api/auditctxApi";
import { cloudAccountApi } from "./api/cloudaccountApi";
import { domainApi } from "./api/domainApi";
import { groupApi } from "./api/groupApi";
import { gvcApi } from "./api/gvcApi";
import { identityApi } from "./api/identityApi";
import { imageApi } from "./api/imageApi";
import { ipSetApi } from "./api/ipSetApi";
import { locationApi } from "./api/locationApi";
import { mk8sApi } from "./api/mk8sApi";
import { orgApi } from "./api/orgApi";
import { policyApi } from "./api/policyApi";
import { quotaApi } from "./api/quotaApi";
import { secretApi } from "./api/secretApi";
import { serviceAccountApi } from "./api/serviceAccountApi";
import { userApi } from "./api/userApi";
import { volumeSetApi } from "./api/volumeSetApi";
import { workloadApi } from "./api/workloadApi";
import { browserApi } from "./api/browserApi";
import { uiDataListenerMiddleware, uiDataReducer } from "./uiDataSlice";
import { userDataReducer } from "./userDataSlice";
import { contextReducer, contextListenerMiddleware } from "./contextSlice";
import { timezoneReducer } from "./timezoneSlice";
import { userListenerMiddleware, userReducer } from "./userSlice";
import { healthReducer } from "./healthSlice";
import { browserServiceReducer } from "./slices/browserServiceSlice";
import { providerBrowserReducer } from "./slices/providerBrowserSlice";
import { workloadReducer } from "./workloadSlice";
import { applyListenerMiddleware, applyReducer } from "./applySlice";
import { formReducer } from "./formSlice";
import { menuReducer } from "./menuSlice";
import { notificationDrawerReducer } from "./notificationDrawerSlice";
import { titleReducer } from "./titleSlice";

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    query: queryReducer,
    discovery: discoveryReducer,
    uiData: uiDataReducer,
    userData: userDataReducer,
    context: contextReducer,
    timezone: timezoneReducer,
    user: userReducer,
    rest: restReducer,
    health: healthReducer,
    browserService: browserServiceReducer,
    providerBrowser: providerBrowserReducer,
    apply: applyReducer,
    form: formReducer,
    menu: menuReducer,
    notificationDrawer: notificationDrawerReducer,
    title: titleReducer,
    // item specific slices
    workload: workloadReducer,
    // Add the RTK Query reducer
    [agentApi.reducerPath]: agentApi.reducer,
    [auditctxApi.reducerPath]: auditctxApi.reducer,
    [cloudAccountApi.reducerPath]: cloudAccountApi.reducer,
    [domainApi.reducerPath]: domainApi.reducer,
    [groupApi.reducerPath]: groupApi.reducer,
    [gvcApi.reducerPath]: gvcApi.reducer,
    [identityApi.reducerPath]: identityApi.reducer,
    [imageApi.reducerPath]: imageApi.reducer,
    [ipSetApi.reducerPath]: ipSetApi.reducer,
    [locationApi.reducerPath]: locationApi.reducer,
    [mk8sApi.reducerPath]: mk8sApi.reducer,
    [orgApi.reducerPath]: orgApi.reducer,
    [policyApi.reducerPath]: policyApi.reducer,
    [quotaApi.reducerPath]: quotaApi.reducer,
    [secretApi.reducerPath]: secretApi.reducer,
    [serviceAccountApi.reducerPath]: serviceAccountApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [volumeSetApi.reducerPath]: volumeSetApi.reducer,
    [workloadApi.reducerPath]: workloadApi.reducer,
    [browserApi.reducerPath]: browserApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(contextListenerMiddleware.middleware)
      .prepend(userListenerMiddleware.middleware)
      .prepend(uiDataListenerMiddleware.middleware)
      .prepend(restListenerMiddleware.middleware)
      .prepend(themeListenerMiddleware.middleware)
      .prepend(applyListenerMiddleware.middleware)
      .concat(agentApi.middleware)
      .concat(auditctxApi.middleware)
      .concat(cloudAccountApi.middleware)
      .concat(domainApi.middleware)
      .concat(groupApi.middleware)
      .concat(gvcApi.middleware)
      .concat(identityApi.middleware)
      .concat(imageApi.middleware)
      .concat(ipSetApi.middleware)
      .concat(locationApi.middleware)
      .concat(mk8sApi.middleware)
      .concat(orgApi.middleware)
      .concat(policyApi.middleware)
      .concat(quotaApi.middleware)
      .concat(secretApi.middleware)
      .concat(serviceAccountApi.middleware)
      .concat(userApi.middleware)
      .concat(volumeSetApi.middleware)
      .concat(workloadApi.middleware)
      .concat(browserApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// store.dispatch(workloadDraftActions.initialize(getDefaultWorkloadInput()));
// setTimeout(() => {
//   console.log("after initialize workload draft slice");
//   console.log(store.getState().workloadDraft);
// }, 10);
